

import {Component, Vue, Watch} from "vue-property-decorator";
import {BildirimEntity} from "@/entity/BildirimEntity";
import {TakipDurumu} from "@/enum/TakipDurumu";
import {ProgramPaths} from "@/enum/ProgramPaths";

@Component({
  components: {}
})
export default class BildirimInfo extends Vue {
  bildirimler: Array<BildirimEntity> = [];
  isNotificationsGetOnce = false;
  bildirimInterval: number | null = null;

  get okunmamisBildirim() {
    if (this.bildirimler.length > 0)
      return this.bildirimler.filter((item) => (!item.okundu_mu)).length;
    else
      return 0;
  }

  get okunmusBildirim() {
    if (this.bildirimler.length > 0)
      return this.bildirimler.filter((item) => (item.okundu_mu)).length;
    else
      return 0;
  }

  getTakipKart(item: BildirimEntity) {


    if (item.takip_durumu === TakipDurumu.acilmamis) {
      this.$router.push(ProgramPaths.icrapro + '/takip-ekle/' + item.takip_id);
    } else {
      this.$router.push(ProgramPaths.icrapro + '/takip/' + item.takip_id);
    }
  }

  @Watch('bildirimler')
  onBildirimlerChange(yeniBildirimler: Array<BildirimEntity>, eskiBildirimler: Array<BildirimEntity>) {
    if (this.isNotificationsGetOnce) {
      let fark: Array<BildirimEntity> = yeniBildirimler.filter(x => {
        return !eskiBildirimler.some((v) => v.id == x.id)
      });
      fark.reverse().forEach((v: BildirimEntity) => {
        this.$toast.info(v.aciklama);
      })
      let userGuncelle = false;
      fark.forEach((bildirim) => bildirim.baslik == 'İzinler Güncellendi' ? (userGuncelle = true) : null);
      if (userGuncelle)
        this.$http.get("/api/v1/ben").then((response) => {
          this.$store.commit('setUser', response);
        })
    }
  }

  mounted() {
    this.bildirimler = [];
    this.fetchBildirimler();
    this.bildirimInterval = window.setInterval(() => {
      this.isNotificationsGetOnce = true;
      this.fetchBildirimler();
    }, 60000);
  }

  beforeDestroy() {
    if (this.bildirimInterval !== null) {
      clearInterval(this.bildirimInterval);
      this.bildirimInterval = null;
    }
  }

  fetchBildirimler() {
    this.$http.get('/api/v1/bildirim').then((response) => {
      this.bildirimler = response.data.reverse();
    });
  }

  tumuOkundu() {
    this.$http.post('/api/v1/bildirim/tumunuOku').then(() => (this.fetchBildirimler()));
  }

  okunanlariTemizle() {
    this.$http.post('/api/v1/bildirim/tumunuOkunduSil').then(() => (this.fetchBildirimler()));
  }

  bildirimiOkuOkuma(bildirim: BildirimEntity) {
    bildirim.okundu_mu = !bildirim.okundu_mu;
    this.$http.put('/api/v1/bildirim/' + bildirim.id, bildirim).then(() => {
      this.fetchBildirimler();
    });
  }
}
